import { AuxiliarMeta } from '~/layers/forms/models'

import { Currency } from './globals/currency'

export type Vehicle = Nullable<{
  manufacturer: AuxiliarMeta
  model: AuxiliarMeta
  version: AuxiliarMeta
  year: number
  type: PropsTypesOf<typeof VehicleTypeEnum>['code']
  use: AuxiliarMeta
  steeringWheelSwap: boolean
}> & {
  amount: Currency
}

function load(model?: Partial<Vehicle> | null): Vehicle {
  return {
    manufacturer: model?.manufacturer ?? AuxiliarMeta.load(),
    model: model?.model ?? AuxiliarMeta.load(),
    version: model?.model ?? AuxiliarMeta.load(),
    year: model?.year ?? null,
    type: model?.type ?? null,
    use: model?.use ?? AuxiliarMeta.load(),
    steeringWheelSwap: model?.steeringWheelSwap ?? false,
    amount: model?.amount ?? Currency.load(),
  }
}

export const VehicleTypeEnum = {
  Automovil: { label: 'Auto', code: 'Automovil', acronyme: 'A' },
  Jeep: { label: 'Jeepetas', code: 'Jeep', acronyme: 'J' },
  Van: { label: 'Furgonetas', code: 'Van', acronyme: 'F' },
  PickupTruck: { label: 'Camionetas', code: 'PickupTruck', acronyme: 'L' },
  Truck: { label: 'Camion', code: 'Truck', acronyme: 'C' },
  Cabezote: { label: 'Cabezote', code: 'Cabezote', acronyme: 'CE' },
  Motocycle: { label: 'Motocicletas', code: 'Motocycle', acronyme: 'M' },
} as const

function getVehicleTypeList(filter: string[] = []) {
  const items = Object.values(VehicleTypeEnum)
  if (filter.length) return items.filter((i) => filter.includes(i.acronyme))
  return items
}

const map = {
  toVehiculoViewModel: (
    model: Vehicle,
    productName: string
  ): SiteApiSchema<'VehiculoViewModel'> => ({
    valorAuto: model.amount.value,
    //moneda: model.amount.currency ?? undefined,
    marca: model.manufacturer?.name,
    marcaId: model.manufacturer?.id,
    modelo: model.model?.name,
    modeloId: model.model?.id,
    usoVehiculo: model.use?.name,
    usoVehiculoId: model.use?.id,
    yearVehiculo: model.year?.toString(),
    version: model.version?.name,
    versionId: model.version?.id,
    tipoModelo: model.type,
    condicion: 'USADO',
    vehiculoProductoNombre: productName,
  }),
}

export const Vehicle = {
  load,
  getVehicleTypeList,
  map,
}
